export default __webpack_public_path__ + "static/media/deepdao_header_new_logo.54fa01ee.svg";